<template>
  <CModal :show.sync="show" centered>
    <template #header>
      <div class="d-flex">
        <CIcon name="cipDownload03" size="custom-size" width="36" height="36"
               class="mr-3 icon-circle icon-circle--primary"/>
        <div class="align-self-center">
          <h5 class="modal-title">
            <translate translate-context="downloader.delivery_choice">How would you like to download?</translate>
          </h5>
        </div>
      </div>
      <CButtonClose @click="onCancel"/>
    </template>

    <p class="text-muted mb-3">
      <translate translate-context="downloader.delivery_choice"
                 :translate-params="{count: request.count}">
        You're about to download %{count} files. Choose how to receive them:
      </translate>
    </p>

    <CButton block color="primary" class="mb-2" @click="onChoose('wait')">
      <CIcon name="cipDownload03" class="mr-2"/>
      <translate translate-context="downloader.delivery_choice">Download now</translate>
    </CButton>
    <CButton block color="primary" variant="outline" @click="onChoose('email')">
      <CIcon name="cipEmail" class="mr-2"/>
      <translate translate-context="downloader.delivery_choice">Email me the link when ready</translate>
    </CButton>

    <template #footer>
      <CButton color="secondary" @click="onCancel">
        <translate translate-context="downloader.delivery_choice">Cancel</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'DownloadDeliveryChoiceModal',
  data() {
    return { show: false }
  },
  computed: {
    ...mapGetters('downloader', ['deliveryChoiceRequest']),
    request() {
      return this.deliveryChoiceRequest || {}
    }
  },
  watch: {
    deliveryChoiceRequest: {
      handler(request) {
        if (request) this.show = true
      },
      immediate: true
    },
    show(val) {
      if (!val && this.deliveryChoiceRequest) {
        this.onCancel()
      }
    }
  },
  methods: {
    ...mapMutations('downloader', ['resolveDeliveryChoiceRequest', 'rejectDeliveryChoiceRequest']),
    onChoose(choice) {
      this.resolveDeliveryChoiceRequest(choice)
      this.show = false
    },
    onCancel() {
      this.rejectDeliveryChoiceRequest()
      this.show = false
    }
  }
}
</script>
